import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Phone, Tag, Zap } from "lucide-react";
import { PHONE, PHONE_TEL } from "@/data/site";
import { track } from "@/lib/analytics";
import { CallbackMini } from "@/components/forms/CallbackMini";

export const PromoPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const openIt = () => setOpen(true);
    const closeIt = () => setOpen(false);
    window.addEventListener("sc-open-promo", openIt);
    window.addEventListener("sc-open-catalog", closeIt);
    return () => {
      window.removeEventListener("sc-open-promo", openIt);
      window.removeEventListener("sc-open-catalog", closeIt);
    };
  }, []);

  const close = () => setOpen(false);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1900] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-testid="promo-popup" onClick={close}>
      <div className="relative w-full max-w-md max-h-[92vh] overflow-y-auto bg-white rounded-3xl shadow-2xl animate-in zoom-in-95 duration-300" onClick={(e) => e.stopPropagation()}>
        <button onClick={close} aria-label="Chiudi" data-testid="promo-close"
          className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 flex items-center justify-center text-slate-600 hover:text-slate-900 shadow">
          <X size={18} />
        </button>

        <div className="px-6 pt-8 pb-6 text-white text-center" style={{ backgroundColor: "var(--sc-emerald)" }}>
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest bg-white/20 px-3 py-1.5 rounded-full">
            <Zap size={14} /> Offerta · solo conferma ordine online
          </span>
          <h2 className="mt-4 text-3xl font-extrabold leading-tight" style={{ fontFamily: "Outfit" }}>Ordina la tua SENIORCAR</h2>
          <p className="mt-3 text-4xl font-extrabold" style={{ fontFamily: "Outfit" }}>€5.490 <span className="text-base font-semibold text-white/85">+ IVA + trasporto</span></p>
        </div>

        <div className="px-6 py-6 text-center">
          <img src="https://static.prod-images.emergentagent.com/jobs/299cb05b-6ca7-4a7d-ab57-ec082781667b/images/6f71b81e390439fc1b5141875032c0790a2a95cca441b5f7109c5e1fc5b3abc4.jpeg"
            alt="SENIORCAR scontornata — dispositivo medico monoposto" loading="lazy"
            className="w-full h-40 object-contain -mt-2 mb-2" data-testid="promo-image" />
          <div className="grid grid-cols-2 gap-2 text-left text-sm">
            <div className="rounded-xl border border-slate-200 bg-slate-100 p-3 opacity-70" aria-disabled="true" data-testid="promo-option-ready">
              <span className="inline-block rounded-full bg-slate-900 text-white text-[10px] font-extrabold uppercase px-2 py-0.5">Esaurito</span>
              <p className="mt-1 text-slate-500 line-through">Consegna 8 giorni · €5.990</p>
            </div>
            <div className="rounded-xl border-2 border-emerald-600 bg-emerald-50 p-3" data-testid="promo-option-production">
              <span className="inline-block rounded-full bg-emerald-600 text-white text-[10px] font-extrabold uppercase px-2 py-0.5">Disponibile</span>
              <p className="mt-1 font-semibold text-slate-900">Consegna 3 mesi · €5.490</p>
            </div>
          </div>

          <Link to="/offerta" data-testid="promo-order-cta"
            onClick={() => { track("promo_order_click", { promo: "order_5990" }); close(); }}
            className="mt-5 flex items-center justify-center gap-2 w-full h-14 rounded-full text-white font-extrabold text-lg transition-transform hover:scale-[1.02]"
            style={{ backgroundColor: "var(--sc-amber)" }}>
            <Tag size={20} /> Prenota Online
          </Link>

          <a href={`tel:${PHONE_TEL}`} data-testid="promo-call-cta"
            onClick={() => { track("promo_call_click", { promo: "order_5990" }); close(); }}
            className="mt-3 inline-flex items-center justify-center gap-2 text-emerald-800 font-semibold hover:underline">
            <Phone size={16} /> Oppure chiama {PHONE}
          </a>
          <div className="mt-4"><CallbackMini source="popup" /></div>
          <p className="mt-4 text-xs text-slate-400">Prezzo riservato alla conferma online. IVA e trasporto esclusi.</p>
        </div>
      </div>
    </div>
  );
};
